module.exports = __webpack_public_path__ + "img/calculator-card-pictures-4.aff299d2.jpg";